import { default as description9UcFyB0iqZMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/config/description.vue?macro=true";
import { default as emptyTdINhzgV4wMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/config/empty.vue?macro=true";
import { default as indexSFjELSnruUMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/config/index.vue?macro=true";
import { default as main6JBebIYnoCMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/config/main.vue?macro=true";
import { default as material8lAnLwB40rMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/config/material.vue?macro=true";
import { default as messageyjiqUSSLRcMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/config/message.vue?macro=true";
import { default as pathl6PgGpHQBOMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/config/path.vue?macro=true";
import { default as indexvpJon8Yve8Meta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/index.vue?macro=true";
import { default as indexn2Nu02Q5X6Meta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/material/index.vue?macro=true";
import { default as activityoYeAKY8zquMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/page/activity.vue?macro=true";
import { default as cartqOZmkaSEkeMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/page/cart.vue?macro=true";
import { default as index3BKcX80oEnMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/page/index.vue?macro=true";
import { default as navbarOHijz6kf3MMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/page/navbar.vue?macro=true";
import { default as order7tLgpw6xvcMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/page/order.vue?macro=true";
import { default as personhx4pw5X76dMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/page/person.vue?macro=true";
import { default as searchqdNm4l0VpWMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/page/search.vue?macro=true";
import { default as descnQE2svU8fXMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/setting/desc.vue?macro=true";
import { default as emptyoKlTyxzYpoMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/setting/empty.vue?macro=true";
import { default as material3Oq3u6RFbTMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/setting/material.vue?macro=true";
import { default as pagesC8zBYmvFldMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/setting/pages.vue?macro=true";
import { default as recommend10q6A45FirMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/setting/recommend.vue?macro=true";
import { default as themeDUXXdW2iRZMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/setting/theme.vue?macro=true";
import { default as addQstGn1wOo9Meta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/template/add.vue?macro=true";
import { default as edittWLa7xKeS9Meta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/template/edit.vue?macro=true";
import { default as indexPn0P54zkHnMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/template/index.vue?macro=true";
import { default as indexMJorw1cozGMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/index.vue?macro=true";
import { default as indexO8jlP8IHtmMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/lang/index.vue?macro=true";
import { default as reloadpI31WxZlovMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reload.vue?macro=true";
import { default as dashboardH9rAgDoOtvMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/dashboard.vue?macro=true";
import { default as faultDz3biW4PAoMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/fault.vue?macro=true";
import { default as listtFViW9hmkzMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/list.vue?macro=true";
import { default as mailITOeB4yrB2Meta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/mail.vue?macro=true";
import { default as message_45sendxPNmvxhoLUMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/message-send.vue?macro=true";
import { default as messagenN7g68FcsiMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/message.vue?macro=true";
import { default as newCn42iuFeMdMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/new.vue?macro=true";
import { default as serviceXhwxQ3n0plMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/service.vue?macro=true";
import { default as storeh4PAhUTd0gMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/store.vue?macro=true";
import { default as visualization4CQ1BxkXQMMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/visualization.vue?macro=true";
import { default as indexg89p9RyKFdMeta } from "D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/test/index.vue?macro=true";
export default [
  {
    name: description9UcFyB0iqZMeta?.name ?? "config-description",
    path: description9UcFyB0iqZMeta?.path ?? "/config/description",
    meta: description9UcFyB0iqZMeta || {},
    alias: description9UcFyB0iqZMeta?.alias || [],
    redirect: description9UcFyB0iqZMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/config/description.vue").then(m => m.default || m)
  },
  {
    name: emptyTdINhzgV4wMeta?.name ?? "config-empty",
    path: emptyTdINhzgV4wMeta?.path ?? "/config/empty",
    meta: emptyTdINhzgV4wMeta || {},
    alias: emptyTdINhzgV4wMeta?.alias || [],
    redirect: emptyTdINhzgV4wMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/config/empty.vue").then(m => m.default || m)
  },
  {
    name: indexSFjELSnruUMeta?.name ?? "config",
    path: indexSFjELSnruUMeta?.path ?? "/config",
    meta: indexSFjELSnruUMeta || {},
    alias: indexSFjELSnruUMeta?.alias || [],
    redirect: indexSFjELSnruUMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/config/index.vue").then(m => m.default || m)
  },
  {
    name: main6JBebIYnoCMeta?.name ?? "config-main",
    path: main6JBebIYnoCMeta?.path ?? "/config/main",
    meta: main6JBebIYnoCMeta || {},
    alias: main6JBebIYnoCMeta?.alias || [],
    redirect: main6JBebIYnoCMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/config/main.vue").then(m => m.default || m)
  },
  {
    name: material8lAnLwB40rMeta?.name ?? "config-material",
    path: material8lAnLwB40rMeta?.path ?? "/config/material",
    meta: material8lAnLwB40rMeta || {},
    alias: material8lAnLwB40rMeta?.alias || [],
    redirect: material8lAnLwB40rMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/config/material.vue").then(m => m.default || m)
  },
  {
    name: messageyjiqUSSLRcMeta?.name ?? "config-message",
    path: messageyjiqUSSLRcMeta?.path ?? "/config/message",
    meta: messageyjiqUSSLRcMeta || {},
    alias: messageyjiqUSSLRcMeta?.alias || [],
    redirect: messageyjiqUSSLRcMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/config/message.vue").then(m => m.default || m)
  },
  {
    name: pathl6PgGpHQBOMeta?.name ?? "config-path",
    path: pathl6PgGpHQBOMeta?.path ?? "/config/path",
    meta: pathl6PgGpHQBOMeta || {},
    alias: pathl6PgGpHQBOMeta?.alias || [],
    redirect: pathl6PgGpHQBOMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/config/path.vue").then(m => m.default || m)
  },
  {
    name: indexvpJon8Yve8Meta?.name ?? "diy",
    path: indexvpJon8Yve8Meta?.path ?? "/diy",
    meta: indexvpJon8Yve8Meta || {},
    alias: indexvpJon8Yve8Meta?.alias || [],
    redirect: indexvpJon8Yve8Meta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/index.vue").then(m => m.default || m)
  },
  {
    name: indexn2Nu02Q5X6Meta?.name ?? "diy-material",
    path: indexn2Nu02Q5X6Meta?.path ?? "/diy/material",
    meta: indexn2Nu02Q5X6Meta || {},
    alias: indexn2Nu02Q5X6Meta?.alias || [],
    redirect: indexn2Nu02Q5X6Meta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/material/index.vue").then(m => m.default || m)
  },
  {
    name: activityoYeAKY8zquMeta?.name ?? "diy-page-activity",
    path: activityoYeAKY8zquMeta?.path ?? "/diy/page/activity",
    meta: activityoYeAKY8zquMeta || {},
    alias: activityoYeAKY8zquMeta?.alias || [],
    redirect: activityoYeAKY8zquMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/page/activity.vue").then(m => m.default || m)
  },
  {
    name: cartqOZmkaSEkeMeta?.name ?? "diy-page-cart",
    path: cartqOZmkaSEkeMeta?.path ?? "/diy/page/cart",
    meta: cartqOZmkaSEkeMeta || {},
    alias: cartqOZmkaSEkeMeta?.alias || [],
    redirect: cartqOZmkaSEkeMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/page/cart.vue").then(m => m.default || m)
  },
  {
    name: index3BKcX80oEnMeta?.name ?? "diy-page",
    path: index3BKcX80oEnMeta?.path ?? "/diy/page",
    meta: index3BKcX80oEnMeta || {},
    alias: index3BKcX80oEnMeta?.alias || [],
    redirect: index3BKcX80oEnMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/page/index.vue").then(m => m.default || m)
  },
  {
    name: navbarOHijz6kf3MMeta?.name ?? "diy-page-navbar",
    path: navbarOHijz6kf3MMeta?.path ?? "/diy/page/navbar",
    meta: navbarOHijz6kf3MMeta || {},
    alias: navbarOHijz6kf3MMeta?.alias || [],
    redirect: navbarOHijz6kf3MMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/page/navbar.vue").then(m => m.default || m)
  },
  {
    name: order7tLgpw6xvcMeta?.name ?? "diy-page-order",
    path: order7tLgpw6xvcMeta?.path ?? "/diy/page/order",
    meta: order7tLgpw6xvcMeta || {},
    alias: order7tLgpw6xvcMeta?.alias || [],
    redirect: order7tLgpw6xvcMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/page/order.vue").then(m => m.default || m)
  },
  {
    name: personhx4pw5X76dMeta?.name ?? "diy-page-person",
    path: personhx4pw5X76dMeta?.path ?? "/diy/page/person",
    meta: personhx4pw5X76dMeta || {},
    alias: personhx4pw5X76dMeta?.alias || [],
    redirect: personhx4pw5X76dMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/page/person.vue").then(m => m.default || m)
  },
  {
    name: searchqdNm4l0VpWMeta?.name ?? "diy-page-search",
    path: searchqdNm4l0VpWMeta?.path ?? "/diy/page/search",
    meta: searchqdNm4l0VpWMeta || {},
    alias: searchqdNm4l0VpWMeta?.alias || [],
    redirect: searchqdNm4l0VpWMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/page/search.vue").then(m => m.default || m)
  },
  {
    name: descnQE2svU8fXMeta?.name ?? "diy-setting-desc",
    path: descnQE2svU8fXMeta?.path ?? "/diy/setting/desc",
    meta: descnQE2svU8fXMeta || {},
    alias: descnQE2svU8fXMeta?.alias || [],
    redirect: descnQE2svU8fXMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/setting/desc.vue").then(m => m.default || m)
  },
  {
    name: emptyoKlTyxzYpoMeta?.name ?? "diy-setting-empty",
    path: emptyoKlTyxzYpoMeta?.path ?? "/diy/setting/empty",
    meta: emptyoKlTyxzYpoMeta || {},
    alias: emptyoKlTyxzYpoMeta?.alias || [],
    redirect: emptyoKlTyxzYpoMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/setting/empty.vue").then(m => m.default || m)
  },
  {
    name: material3Oq3u6RFbTMeta?.name ?? "diy-setting-material",
    path: material3Oq3u6RFbTMeta?.path ?? "/diy/setting/material",
    meta: material3Oq3u6RFbTMeta || {},
    alias: material3Oq3u6RFbTMeta?.alias || [],
    redirect: material3Oq3u6RFbTMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/setting/material.vue").then(m => m.default || m)
  },
  {
    name: pagesC8zBYmvFldMeta?.name ?? "diy-setting-pages",
    path: pagesC8zBYmvFldMeta?.path ?? "/diy/setting/pages",
    meta: pagesC8zBYmvFldMeta || {},
    alias: pagesC8zBYmvFldMeta?.alias || [],
    redirect: pagesC8zBYmvFldMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/setting/pages.vue").then(m => m.default || m)
  },
  {
    name: recommend10q6A45FirMeta?.name ?? "diy-setting-recommend",
    path: recommend10q6A45FirMeta?.path ?? "/diy/setting/recommend",
    meta: recommend10q6A45FirMeta || {},
    alias: recommend10q6A45FirMeta?.alias || [],
    redirect: recommend10q6A45FirMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/setting/recommend.vue").then(m => m.default || m)
  },
  {
    name: themeDUXXdW2iRZMeta?.name ?? "diy-setting-theme",
    path: themeDUXXdW2iRZMeta?.path ?? "/diy/setting/theme",
    meta: themeDUXXdW2iRZMeta || {},
    alias: themeDUXXdW2iRZMeta?.alias || [],
    redirect: themeDUXXdW2iRZMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/setting/theme.vue").then(m => m.default || m)
  },
  {
    name: addQstGn1wOo9Meta?.name ?? "diy-template-add",
    path: addQstGn1wOo9Meta?.path ?? "/diy/template/add",
    meta: addQstGn1wOo9Meta || {},
    alias: addQstGn1wOo9Meta?.alias || [],
    redirect: addQstGn1wOo9Meta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/template/add.vue").then(m => m.default || m)
  },
  {
    name: edittWLa7xKeS9Meta?.name ?? "diy-template-edit",
    path: edittWLa7xKeS9Meta?.path ?? "/diy/template/edit",
    meta: edittWLa7xKeS9Meta || {},
    alias: edittWLa7xKeS9Meta?.alias || [],
    redirect: edittWLa7xKeS9Meta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/template/edit.vue").then(m => m.default || m)
  },
  {
    name: indexPn0P54zkHnMeta?.name ?? "diy-template",
    path: indexPn0P54zkHnMeta?.path ?? "/diy/template",
    meta: indexPn0P54zkHnMeta || {},
    alias: indexPn0P54zkHnMeta?.alias || [],
    redirect: indexPn0P54zkHnMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/diy/template/index.vue").then(m => m.default || m)
  },
  {
    name: indexMJorw1cozGMeta?.name ?? "index",
    path: indexMJorw1cozGMeta?.path ?? "/",
    meta: indexMJorw1cozGMeta || {},
    alias: indexMJorw1cozGMeta?.alias || [],
    redirect: indexMJorw1cozGMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexO8jlP8IHtmMeta?.name ?? "lang",
    path: indexO8jlP8IHtmMeta?.path ?? "/lang",
    meta: indexO8jlP8IHtmMeta || {},
    alias: indexO8jlP8IHtmMeta?.alias || [],
    redirect: indexO8jlP8IHtmMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/lang/index.vue").then(m => m.default || m)
  },
  {
    name: reloadpI31WxZlovMeta?.name ?? "reload",
    path: reloadpI31WxZlovMeta?.path ?? "/reload",
    meta: reloadpI31WxZlovMeta || {},
    alias: reloadpI31WxZlovMeta?.alias || [],
    redirect: reloadpI31WxZlovMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reload.vue").then(m => m.default || m)
  },
  {
    name: dashboardH9rAgDoOtvMeta?.name ?? "reservation-dashboard",
    path: dashboardH9rAgDoOtvMeta?.path ?? "/reservation/dashboard",
    meta: dashboardH9rAgDoOtvMeta || {},
    alias: dashboardH9rAgDoOtvMeta?.alias || [],
    redirect: dashboardH9rAgDoOtvMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/dashboard.vue").then(m => m.default || m)
  },
  {
    name: faultDz3biW4PAoMeta?.name ?? "reservation-fault",
    path: faultDz3biW4PAoMeta?.path ?? "/reservation/fault",
    meta: faultDz3biW4PAoMeta || {},
    alias: faultDz3biW4PAoMeta?.alias || [],
    redirect: faultDz3biW4PAoMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/fault.vue").then(m => m.default || m)
  },
  {
    name: listtFViW9hmkzMeta?.name ?? "reservation-list",
    path: listtFViW9hmkzMeta?.path ?? "/reservation/list",
    meta: listtFViW9hmkzMeta || {},
    alias: listtFViW9hmkzMeta?.alias || [],
    redirect: listtFViW9hmkzMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/list.vue").then(m => m.default || m)
  },
  {
    name: mailITOeB4yrB2Meta?.name ?? "reservation-mail",
    path: mailITOeB4yrB2Meta?.path ?? "/reservation/mail",
    meta: mailITOeB4yrB2Meta || {},
    alias: mailITOeB4yrB2Meta?.alias || [],
    redirect: mailITOeB4yrB2Meta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/mail.vue").then(m => m.default || m)
  },
  {
    name: message_45sendxPNmvxhoLUMeta?.name ?? "reservation-message-send",
    path: message_45sendxPNmvxhoLUMeta?.path ?? "/reservation/message-send",
    meta: message_45sendxPNmvxhoLUMeta || {},
    alias: message_45sendxPNmvxhoLUMeta?.alias || [],
    redirect: message_45sendxPNmvxhoLUMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/message-send.vue").then(m => m.default || m)
  },
  {
    name: messagenN7g68FcsiMeta?.name ?? "reservation-message",
    path: messagenN7g68FcsiMeta?.path ?? "/reservation/message",
    meta: messagenN7g68FcsiMeta || {},
    alias: messagenN7g68FcsiMeta?.alias || [],
    redirect: messagenN7g68FcsiMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/message.vue").then(m => m.default || m)
  },
  {
    name: newCn42iuFeMdMeta?.name ?? "reservation-new",
    path: newCn42iuFeMdMeta?.path ?? "/reservation/new",
    meta: newCn42iuFeMdMeta || {},
    alias: newCn42iuFeMdMeta?.alias || [],
    redirect: newCn42iuFeMdMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/new.vue").then(m => m.default || m)
  },
  {
    name: serviceXhwxQ3n0plMeta?.name ?? "reservation-service",
    path: serviceXhwxQ3n0plMeta?.path ?? "/reservation/service",
    meta: serviceXhwxQ3n0plMeta || {},
    alias: serviceXhwxQ3n0plMeta?.alias || [],
    redirect: serviceXhwxQ3n0plMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/service.vue").then(m => m.default || m)
  },
  {
    name: storeh4PAhUTd0gMeta?.name ?? "reservation-store",
    path: storeh4PAhUTd0gMeta?.path ?? "/reservation/store",
    meta: storeh4PAhUTd0gMeta || {},
    alias: storeh4PAhUTd0gMeta?.alias || [],
    redirect: storeh4PAhUTd0gMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/store.vue").then(m => m.default || m)
  },
  {
    name: visualization4CQ1BxkXQMMeta?.name ?? "reservation-visualization",
    path: visualization4CQ1BxkXQMMeta?.path ?? "/reservation/visualization",
    meta: visualization4CQ1BxkXQMMeta || {},
    alias: visualization4CQ1BxkXQMMeta?.alias || [],
    redirect: visualization4CQ1BxkXQMMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/reservation/visualization.vue").then(m => m.default || m)
  },
  {
    name: indexg89p9RyKFdMeta?.name ?? "test",
    path: indexg89p9RyKFdMeta?.path ?? "/test",
    meta: indexg89p9RyKFdMeta || {},
    alias: indexg89p9RyKFdMeta?.alias || [],
    redirect: indexg89p9RyKFdMeta?.redirect,
    component: () => import("D:/Project/Lanyun/Stamford Tyres/stamford_tyres_backend/pages/test/index.vue").then(m => m.default || m)
  }
]